import { render, staticRenderFns } from "./UserEnableModal.vue?vue&type=template&id=28612490&scoped=true&"
import script from "./UserEnableModal.vue?vue&type=script&lang=ts&"
export * from "./UserEnableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28612490",
  null
  
)

export default component.exports